import {documentToHtmlString} from "@contentful/rich-text-html-renderer"
import clsx from "clsx"
import React from "react"
import "./RichText.css"

export interface RichTextFieldProps extends React.HTMLAttributes<HTMLDivElement> {}

const RichTextField: React.FC<RichTextFieldProps> = props => {
    const {children, className, ...otherPros} = props

    if (typeof children !== "string") return null

    return (
        <div
            className={clsx("rich-56aq", className)}
            dangerouslySetInnerHTML={children ? {__html: documentToHtmlString(JSON.parse(children))} : undefined}
            {...otherPros}
        />
    )
}

export default RichTextField
